import { COMPANIES, CONTACTS, OPPORTUNITIES } from 'constants/Entities';
import { getLiteral, getLiteralWithParameters } from 'utils/getLiteral';

/**
 * Returns the hint config for a cross-filter section, only when that hint applies to the current view.
 * E.g. accounts/contacts section hints are only shown when viewing Opportunities.
 *
 * @param {string} contextEntityName - Entity being viewed (e.g. 'opportunities')
 * @param {string} crossSectionEntity - Entity of the cross-filter section (e.g. 'companies', 'contacts')
 * @returns {{ description: string } | undefined}
 */
export const getCrossFilterSectionHint = (contextEntityName, crossSectionEntity) => {
    const hintsByContextEntity = {
        [OPPORTUNITIES.entity]: {
            [COMPANIES.entity]: {
                description: getLiteralWithParameters('label_opportunities_crossfilters_accounts', [
                    getLiteral('label_account_client'),
                    getLiteral('label_account_middleman'),
                    getLiteral('label_intermediary2'),
                ]),
            },
            [CONTACTS.entity]: {
                description: getLiteral('label_opportunities_crossfilters_contacts'),
            },
        },
    };

    return hintsByContextEntity[contextEntityName]?.[crossSectionEntity];
};
